import React, { useEffect, useRef } from "react";
import { CenterSpinner, useAuth, useLogin } from "@soap/modules";
import { getPostLoginReturnUrl } from "../constants/postLoginReturnUrl";

/**
 * Landing route for static marketing pages: loads the SPA, then starts Auth0 login
 * (same as clicking Log In in the main nav).
 */
export function AuthLoginRedirect() {
    const maintenance = window.LYW?.maintenance === true;
    const { authReady, authEnabled, isAuthenticated } = useAuth();
    const { logIn } = useLogin();
    const loginStarted = useRef(false);

    useEffect(() => {
        if (maintenance) return;
        if (!authReady || !authEnabled) return;
        if (isAuthenticated) {
            window.location.replace(`${window.location.origin}/#/app`);
            return;
        }
        if (loginStarted.current) return;
        loginStarted.current = true;
        logIn(getPostLoginReturnUrl());
    }, [authReady, authEnabled, isAuthenticated, maintenance, logIn]);

    if (maintenance) {
        return (
            <div
                style={{
                    minHeight: "40vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Lato, sans-serif",
                    color: "#656565",
                    padding: "2rem",
                    textAlign: "center",
                }}
            >
                Sign-in is temporarily unavailable while we perform maintenance.
            </div>
        );
    }

    return (
        <div
            style={{
                minHeight: "50vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
            }}
        >
            <CenterSpinner />
            <p style={{ fontFamily: "Lato, sans-serif", color: "#656565", fontSize: "15px" }}>
                Redirecting to sign in…
            </p>
        </div>
    );
}
